import React from 'react';
import {
  UncontrolledDropdown, DropdownToggle, DropdownMenu,
} from 'reactstrap';
import IconButton from 'app/components/general/IconButton';
import DotsIcon from 'app/images/icons/dots-filled.svg';

interface IActionDotsProps {
  children?: any;
  id?: string;
  className?: string;
}

export default class ActionDots extends React.Component<
  IActionDotsProps,
  {}
> {
  static defaultProps: IActionDotsProps = {
    className: '',
  }

  render(): React.ReactNode {
    return (
      <UncontrolledDropdown
        direction="down"
        className="d-inline-block"
      >
        <div onClick={(e) => e.stopPropagation()}>
          <DropdownToggle
            tag="div"
            className=""
            data-toggle="dropdown"
          >
            <IconButton
              icon={DotsIcon}
              id={`menu-${this.props.id}`}
              className="btn dots-icon"
            />
          </DropdownToggle>
          <DropdownMenu positionFixed>
            {this.props.children}
          </DropdownMenu>
        </div>
      </UncontrolledDropdown>
    );
  }
}
